import MenuConfigType from '@app/types/MenuConfigType';
import { MenuItem } from '@app/redux/types/authTypes/auth';
import { FeaturesConfig } from '@app/redux/types/ConfigState';

const isFeatureEnabled = (item: MenuConfigType, features?: FeaturesConfig): boolean => {
  if (!item.featureFlag) return true;
  return features?.[item.featureFlag] === true;
};

const resolveBadge = (item: MenuConfigType, features?: FeaturesConfig): string | undefined => {
  if (!item.badge) return undefined;
  if (!item.badgeFeatureFlag) return item.badge;
  return features?.[item.badgeFeatureFlag] === true ? item.badge : undefined;
};

const mapMenuConfig = (
  menuConfig: MenuConfigType[],
  menuItems: MenuItem[],
  t?: (key: string) => string,
  features?: FeaturesConfig
): MenuConfigType[] => {
  return menuConfig.map((item) => {
    const featureEnabled = isFeatureEnabled(item, features);
    const badge = resolveBadge(item, features);
    const foundItem = menuItems.find((val) => val.key === item.key);
    if (foundItem) {
      return {
        ...item,
        badge,
        privileged: featureEnabled,
        title: t ? t(foundItem.key.replace(/^./, c => c.toLowerCase())) : foundItem.name,
        order: foundItem.order,
        children: item.children ? mapMenuConfig(item.children, foundItem.subMenus, t, features) : [],
      };
    } else {
      return {
        ...item,
        badge,
        privileged: item.privileged === true && featureEnabled,
      };
    }
  });
};

export default mapMenuConfig;
